import { Badge, FlexBox } from '@dixa/lib-shared-habla';
import { memo, useMemo } from 'react';

import { useAppSelector } from 'utils/redux/useAppSelector';

type MessagingQueueDetailsProps = {
  queueId: string;
};

export const MessagingQueueDetails = memo(function MessagingQueueDetails({
  queueId,
}: MessagingQueueDetailsProps): JSX.Element {
  const queues = useAppSelector((state) => state.settings.queues.queues);

  const queue = useMemo(
    () => queues.find((queue) => queue.id === queueId),
    [queueId, queues],
  );

  if (queue) {
    return (
      <FlexBox gap="100" alignItems="center">
        <span>{queue.name}</span>

        {queue.is_archived && (
          <Badge variant="error" size="small">
            Archived
          </Badge>
        )}
      </FlexBox>
    );
  }
  return <p>Loading...</p>;
});
